"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable class-methods-use-this */
// this is necessary for @abstract methods
var moment = require('moment');

var isUndefined = require('lodash/isUndefined');

var flatten = require('lodash/flatten');

var ComponentCollection = require('./ComponentCollection');

var ShinePricing = require('../../pricing/ShinePricing');

var Personalization = require('./Personalization');
/**
 * @interface
 * @example
 * const suite = ShineProducts.instance().make({ product_type: ShineProduct.constants.CLASSIC_WEDDING_INVITATIONS })
 * // => suite<Product>
 * suite.invitations.add()
 * suite.all()
 * suite.set()
 */


var Product = /*#__PURE__*/function () {
  function Product() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Product);

    this.product_type = params.product_type || 'Product';
    this.created_at = params.created_at ? moment(params.created_at) : moment();
    this.setComponentCollections = this.setComponentCollections.bind(this);
    this.setPriceTableVersions = this.setPriceTableVersions.bind(this);
    this.customer_notes = params.customer_notes || null;
    this.file_display_name = params.file_display_name || null;
    this.file_server_name = params.file_server_name || null;
    this.storage_bucket = params.storage_bucket || null;
    this.contact_email = params.contact_email ? params.contact_email.trim().toLowerCase() : null; // this.subtotal = parseInt(params.subtotal, 10) || 0;

    this.event_date = params.event_date ? moment(params.event_date) : null;
    this.personalization = params.personalization && Array.isArray(params.personalization) ? params.personalization.map(function (item) {
      return new Personalization(item);
    }) : [];
  }

  _createClass(Product, [{
    key: "type",
    get: function get() {
      return this.product_type.replace(/\s/g, '');
    }
    /**
     * safely sets a parameter if that parameter is valid
     * @param {*} input.parameter
     * @param {*} input.value
     * @returns {self}
     */

  }, {
    key: "set",
    value: function set(obj) {
      var _this = this;

      if (Object.prototype.toString.call(obj) !== '[object Object]') {
        throw new Error('set() must receive an object!');
      }

      Object.keys(obj).forEach(function (parameter) {
        if (!Object.prototype.hasOwnProperty.call(_this, parameter)) {
          throw new Error("".concat(parameter, " is not a valid parameter"));
        }

        _this[parameter] = obj[parameter];
      });
      return this;
    }
    /**
     * get all product components
     * @returns {ComponentCollection[]}
     */

  }, {
    key: "all",
    value: function all() {
      return this.components;
    }
  }, {
    key: "subcomponents",
    value: function subcomponents() {
      var _this2 = this;

      var constructors = this.constructors;
      var subcomponents = flatten(Object.keys(constructors).map(function (key) {
        return _this2[key].subcomponents();
      }));
      return subcomponents.filter(function (_ref) {
        var quantity = _ref.quantity;
        return quantity > 0;
      });
    }
    /**
     * get all components by type
     *
     * @returns {Array<Component>}
     */

  }, {
    key: "components",
    get: function get() {
      var _this3 = this;

      var constructors = this.constructors;
      var components = [];
      Object.keys(constructors).forEach(function (key) {
        _this3[key].all().filter(function (_ref2) {
          var quantity = _ref2.quantity;
          return quantity > 0;
        }).forEach(function (comp) {
          return components.push(comp);
        });
      });
      return components;
    },
    set: function set(arr) {
      var _this4 = this;

      Object.keys(this.constructors).forEach(function (key) {
        var Constructor = _this4.constructors[key];
        var type = new Constructor().type;
        var comps = arr.filter(function (comp) {
          return comp.component_type === type;
        });
        _this4[key] = new ComponentCollection(comps, Constructor);
      });
    }
    /**
     * get all component collections
     */

  }, {
    key: "collections",
    get: function get() {
      var _this5 = this;

      var c = {};
      Object.keys(this.constructors).forEach(function (componentName) {
        c[componentName] = _this5[componentName];
      });
      return c;
    }
    /**
     * get the subtotal
     */

  }, {
    key: "subtotal",
    get: function get() {
      var val = 0;

      try {
        val = ShinePricing.instance().calculatePrice(this);
      } catch (error) {
        console.error(error);
      }

      return val;
    }
    /**
     * get the split fee
     */

  }, {
    key: "split_fee",
    get: function get() {
      return ShinePricing.instance().calculateSplitFee(this);
    }
  }, {
    key: "component_weights",
    get: function get() {
      var _this6 = this;

      return this.components.map(function (component) {
        return {
          component_weight: component.component_weight(_this6.paper_type),
          component_type: component.component_type
        };
      });
    }
  }, {
    key: "instance_weight",
    get: function get() {
      var _this7 = this;

      return this.components.map(function (comp) {
        return comp.component_weight(_this7.paper_type);
      }).reduce(function (p, v) {
        return p + v;
      }, 0);
    }
  }, {
    key: "weight",
    get: function get() {
      var _this8 = this;

      return this.components.map(function (comp) {
        return comp.total_weight(_this8.paper_type);
      }).reduce(function (p, v) {
        return p + v;
      }, 0);
    }
    /**
     * Sets the component collections. Should be run directly after construction.
     * @param {*} params
     */

  }, {
    key: "setComponentCollections",
    value: function setComponentCollections(params) {
      var _this9 = this;

      if (isUndefined(this.constructors)) {
        throw new Error('Class must implement prototype.constructors!');
      }

      var constructors = this.constructors;
      Object.keys(constructors).forEach(function (key) {
        var Constructor = constructors[key];
        _this9[key] = new ComponentCollection(params[key], Constructor);
      });
      this.constructors = constructors;
    }
    /**
     * Sets the price table versions. Should be run directly after construction.
     * @param {*} params
     */

  }, {
    key: "setPriceTableVersions",
    value: function setPriceTableVersions(params) {
      ShinePricing.instance().setPriceTableVersions.call(this, params);
    }
    /**
     * sets the product's default components
     * @abstract
     */

  }, {
    key: "defaults",
    value: function defaults() {
      throw new Error('Product must implement defaults()');
    }
  }]);

  return Product;
}();

module.exports = Product;